export default "__VITE_ASSET__Dclf56NW__"